import { DeviceState } from 'src/Libs/api'

export type { UnitType as Unit } from 'src/Libs/types'
export enum RotationDirection {
  notDefined = 0,
  right = 1,
  left = 2,
}

export type TachoGraphVersion = 'light' | 'main'
export type SystemStatusType = 'running' | 'service' | 'between' | 'missing'

export interface PvInverterIds {
  ids: number[]
}

export interface ServerPvInverterIds {
  [key: string]: number[]
}

export type PvInverterIdTypes = PvInverterIds | ServerPvInverterIds
export interface SolarSocketModule {
  pviAcVoltage: number[]
  pviAcPower: number[]
  pviAcCurrent: number[]
  pviDcPower: number[]
  pviDcVoltage: number[]
  pviDcCurrent: number[]
  pviTemperature: number[]
  pviAcApparentPower: number[]
  pviAcReactivePower: number[]
}
export interface SolarModule {
  pviIndex: number
  pviSerialNumber: string
  pviAcVoltage: GraphDataModel
  pviAcPower: GraphDataModel
  pviAcCurrent: GraphDataModel
  pviDcPower: GraphDataModel
  pviDcVoltage: GraphDataModel
  pviDcCurrent: GraphDataModel
  pviRotaryFieldDirection: 0 | 1 | 2
  pviTemperature: GraphDataModel
  pviLastError: string
  pviState: string
  pviDeviceState: PviDeviceState
  pviAcApparentPower: GraphDataModel
  pviAcReactivePower: GraphDataModel
  pviEnergyAll: number[]
  pviTracker: PviTracker
  storageId?: string
}

export enum PvTrackerType {
  single = 1,
  double = 2,
  triple = 3,
}

export type PviTracker = PvTrackerType

export interface GraphDataModel {
  min: number
  max: number
  count: number
  values: number[]
}

export interface PviDeviceState {
  pviDeviceConnected: boolean
  pviDeviceWorking: boolean
  pviDeviceInService: boolean
}

export interface SelectedValue {
  index: number
  isSelected: boolean
}

export const getSystemStatusByDeviceState = (deviceState: DeviceState): SystemStatusType => {
  if (deviceState.inService) {
    return 'service'
  } else if (deviceState.working) {
    return 'running'
  } else if (deviceState.connected) {
    return 'between'
  }
  return 'missing'
}
